var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMentorAppIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1108_30498)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6H38V27H23V29H38C39.1046 29 40 28.1046 40 27V6C40 4.89543 39.1046 4 38 4H12C10.8954 4 10 4.89543 10 6V9H12V6Z",
    fill: "#95A3B9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 18.41L21.41 16L25.41 20L31.71 13.71L34 16V10H28L30.29 12.29L25.41 17.17L21.41 13.17L19 15.5833V18.41Z",
    fill: "#95A3B9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99805 25.8333C13.3355 25.8333 19.998 27.5083 19.998 30.8333V33.3333H-0.00195312V30.8333C-0.00195312 27.5083 6.66055 25.8333 9.99805 25.8333Z",
    fill: "#95A3B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99805 23.3333C12.7605 23.3333 14.998 21.0958 14.998 18.3333C14.998 15.5708 12.7605 13.3333 9.99805 13.3333C7.23555 13.3333 4.99805 15.5708 4.99805 18.3333C4.99805 21.0958 7.23555 23.3333 9.99805 23.3333Z",
    fill: "#95A3B9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1108_30498"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 33.3333,
    fill: "white",
    transform: "translate(0 3.33334)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentorAppIcon);
export default __webpack_public_path__ + "static/media/mentor-app-icon.f9055e4b.svg";
export { ForwardRef as ReactComponent };